import { useToastMessage } from "@poseidon/ui/app/toasts/useToastMessage";
import Dialog from "@mui/material/Dialog";
import { Field, Formik } from "formik";
import Form from "@poseidon/ui/components/form/FullWidthForm";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import { FullWidthField } from "@poseidon/ui/components";
import DialogActions from "@mui/material/DialogActions";
import { Alert, Button } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { green } from "@mui/material/colors";
import { useAddDoc } from "@poseidon/firebase";
import config from "@poseidon/utils/config";
import { db } from "@poseidon/firebase/firebase";
import { collection } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";

const { SaltCollection } = config;

const initialValues = {
  contactEmail: "",
  companyName: "",
};
export const validationSchema = Yup.object().shape({
  contactEmail: Yup.string()
    .email("Invalid Email")
    .required("Must not be blank"),
  companyName: Yup.string().required("Must not be blank"),
});

export function CreateDealerModal({ open, onClose }) {
  const { setToast } = useToastMessage();
  const navigate = useNavigate();
  const [addDealer, savingDealer, addDealerError] = useAddDoc(
    collection(db, SaltCollection.Dealer)
  );
  const onSubmitHandler = async (values) => {
    console.log(values);
    addDealer(values).then((ref) => {
      if (ref) {
        setToast("Successfully created dealer");
        onClose();
        navigate(`/dealers/${ref.id}`);
      }
    });
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmitHandler}
        validationSchema={validationSchema}
      >
        <Form>
          <DialogTitle>Create Dealer</DialogTitle>
          <DialogContent>
            <Field
              component={FullWidthField}
              name="contactEmail"
              label="Contact Email"
              margin="normal"
            />
            <Field
              component={FullWidthField}
              name="companyName"
              label="Company Name"
              margin="normal"
            />
            {addDealerError && <Alert severity="error">{addDealerError}</Alert>}
          </DialogContent>
          <DialogActions>
            <Button onClick={onClose} disabled={savingDealer}>
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              margin="normal"
              disabled={savingDealer}
            >
              Submit
            </Button>
            {savingDealer && (
              <CircularProgress
                size={24}
                sx={{
                  color: green[500],
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  marginTop: "-12px",
                  marginLeft: "-12px",
                }}
              />
            )}
          </DialogActions>
        </Form>
      </Formik>
    </Dialog>
  );
}
